export class StringUtils {
  public static convert(code: string, data: any) {
    let parsedCode = code;
    const regex = /{.+?}/g;
    let arr;
    while ((arr = regex.exec(code)) != null) {
      const dataForKey = StringUtils.getDataForKey(data, arr[0].substr(1, arr[0].length - 2).split('.'));
      parsedCode = parsedCode.replace(arr[0], dataForKey);
    }
    return parsedCode;
  }

  public static getDataForKey(result: any, key: string[]) {
    if (key.length === 0 || !result) {
      return result || 0;
    }
    return this.getDataForKey(result[key[0]], key.splice(1));
  }
}
